import { render, staticRenderFns } from "./LmPassengerWizard.vue?vue&type=template&id=147b3356"
import script from "./LmPassengerWizard.vue?vue&type=script&lang=js"
export * from "./LmPassengerWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports